import { ref } from "vue";
import { generateError } from "@/shared/utils";
import { getOneParvandeh } from "@/modules/profile/services";

export default function setup(parvandehCode) {
  const selectedRolesLoading = ref(false);
  const selectedRoles = ref([]);
  const getParvandehData = async () => {
    try {
      selectedRolesLoading.value = true;
      const response = await getOneParvandeh(parvandehCode);
      const { roles } = response;
      selectedRoles.value = [...selectedRoles.value, ...roles];
    } catch (error) {
      generateError(error);
    } finally {
      selectedRolesLoading.value = false;
    }
  };
  getParvandehData();

  const handleRemoveRole = (code) => {
    selectedRoles.value = [
      ...selectedRoles.value.filter((role) => role.code !== code),
    ];
  };
  const handleRoleSelect = (selected, item) => {
    if (selected) {
      selectedRoles.value = [...selectedRoles.value, item];
    } else {
      const { code } = item;
      handleRemoveRole(code);
    }
  };

  return {
    selectedRolesLoading,
    selectedRoles,
    handleRemoveRole,
    handleRoleSelect,
  };
}
